module.exports = __webpack_public_path__ + "Tinebase/js/ace-mode-c_cpp-FAT.js";